/**
 * @module utils
 * @private
 */

/**
 * Initializes an access protected object for private attributes.
 *
 * @param self Object to extend with private attributes.
 * @param privateKey Private key for the passed object.
 * @param data Attributes object for extension.
 */
export default function initPrivateData(self, privateKey, data) {
  Object.defineProperty(self, "_getPrivateData", {
    configurable: false,
    enumerable: false,
    writable: false,
    value: function getPrivateData(key) {
      if (key !== privateKey) {
        throw new Error("Illegal access");
      } else {
        return data;
      }
    }
  });
}
